import { useEffect, useRef } from "react";

/**
 * Fullscreen looping video layer with audio. Rendered on top of everything on
 * the overlay when the operator toggles "Vis video". Chromakey-safe: it either
 * covers the whole screen (opaque video) or is fully unmounted — no opacity
 * transitions.
 */
export function LoopVideoLayer({ show, version, api }) {
  const videoRef = useRef(null);

  useEffect(() => {
    if (!show) return;
    const v = videoRef.current;
    if (!v) return;
    // Try to play with sound. Broadcast tools (vMix/OBS CEF) allow autoplay
    // with audio; a normal browser may block it, in which case we retry muted
    // so the picture still plays.
    const tryPlay = async () => {
      try {
        v.muted = false;
        await v.play();
      } catch (e) {
        try {
          v.muted = true;
          await v.play();
        } catch (e2) { /* ignore */ }
      }
    };
    tryPlay();
  }, [show, version]);

  if (!show || !version) return null;

  const src = `${api}/video/current?v=${version}`;
  return (
    <div
      data-testid="loop-video-layer"
      style={{
        position: "absolute",
        inset: 0,
        width: "100vw",
        height: "100vh",
        zIndex: 60,
        backgroundColor: "#000000",
      }}
    >
      <video
        ref={videoRef}
        src={src}
        autoPlay
        loop
        playsInline
        controls={false}
        style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
      />
    </div>
  );
}
